module.exports = __webpack_public_path__ + "static/media/01.3ba9f03f.jpg";